import { render, staticRenderFns } from "./resizer.vue?vue&type=template&id=2e4a5796&scoped=true"
import script from "./resizer.vue?vue&type=script&lang=js"
export * from "./resizer.vue?vue&type=script&lang=js"
import style0 from "./resizer.vue?vue&type=style&index=0&id=2e4a5796&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4a5796",
  null
  
)

export default component.exports